import ProjectWorld, { createServerEvent, ProjectEventType } from "../ProjectWorld";
import type { BaseEvent, BaseProjectionResult, BaseEventInput, EventProcessor } from "@utilitydelta/clientside-event-sourcing";
import { ServerEvent } from "@utilitydelta/eventplanedb-client";

export const MINOR_VERSION: number = 1;

export interface ProvidedSymmetricKey_LocalEvent extends BaseEvent<ProjectEventType> {
    tp: typeof ProjectEventType.ProvidedSymmetricKey;
    publicKey: string; // Public key so we know who can decrypt the symmetric key
    encryptedSymmetricKey: string; // symmetric key encrypted with publicKey
}

export interface ProvidedSymmetricKey_ProjectionResult extends BaseProjectionResult {
    kind: 'ProvidedSymmetricKey_ProjectionResult';
}

export interface ProvidedSymmetricKey_EventInputs extends BaseEventInput {
    kind: 'ProvidedSymmetricKey_EventInputs';
    publicKey: string; // Public key so we know who can decrypt the symmetric key
    encryptedSymmetricKey: string; // symmetric key encrypted with publicKey
}

export type ProvidedSymmetricKey_EventProcessorType = EventProcessor<ProjectEventType, ProvidedSymmetricKey_EventInputs, ProvidedSymmetricKey_LocalEvent, ProvidedSymmetricKey_ProjectionResult, ProvidedSymmetricKey_LocalEvent, ServerEvent<ProjectEventType>>;

export class ProvidedSymmetricKey_EventProcessor implements ProvidedSymmetricKey_EventProcessorType {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(_pw: ProjectWorld) { }

    public get shouldEncrypt(): boolean { return false; }
    public get eventType(): ProjectEventType { return ProjectEventType.ProvidedSymmetricKey; }
    public get eventTypeMinorVersion(): number { return MINOR_VERSION; }
    public get undoEventType(): ProjectEventType { return ProjectEventType.ProvidedSymmetricKey; }
    public get undoEventTypeMinorVersion(): number { return MINOR_VERSION; }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public createUndoEvent = (_undoEvent: ProvidedSymmetricKey_LocalEvent, _originalEventProjectionResult: ProvidedSymmetricKey_ProjectionResult): boolean => {
        return false;
    }

    public projectOntoWorld = (_event: ProvidedSymmetricKey_LocalEvent, _addUpdatedEntitiesToDirtySet: boolean, returnProjectionResults: boolean): ProvidedSymmetricKey_ProjectionResult | undefined => {



        return !returnProjectionResults ? undefined : {
            kind: 'ProvidedSymmetricKey_ProjectionResult',
        };
    }

    public createLocalEvent = (eventToPopulate: ProvidedSymmetricKey_LocalEvent, userInputs: ProvidedSymmetricKey_EventInputs): boolean => {
        eventToPopulate.encryptedSymmetricKey = userInputs.encryptedSymmetricKey;
        eventToPopulate.publicKey = userInputs.publicKey;

        return true;
    }

    public toServerEvent = async (localEvent: ProvidedSymmetricKey_LocalEvent): Promise<ServerEvent<ProjectEventType>> => {
        const eventData = {
            encryptedSymmetricKey: localEvent.encryptedSymmetricKey,
            publicKey: localEvent.publicKey,
        };
        const eventDataString = JSON.stringify(eventData);
        const serverEvent = createServerEvent(localEvent, eventDataString);
        return serverEvent;
    }

    public fromServerEvent = async (localEventToPopulate: ProvidedSymmetricKey_LocalEvent, serverEvent: ServerEvent<ProjectEventType>): Promise<void> => {
        const eventData = JSON.parse(atob(serverEvent.ev))
        Object.assign(localEventToPopulate, eventData);
    }
}